<a class="page-header__icon inline-block m-r-2 m-r-0-m m-r-0-s p-b-1-s"
   routerLink="/account/wishlist"
   routerLinkActive="is-active"
   [attr.aria-label]="'Wishlist quantity ' + wishlist?.qty"
   [attr.qty-bullet]="wishlist?.qty || undefined"
   cy-wishlistBtnMenu>
    <i class="icon-wishlist"
       [style.font-size.px]="24"
       aria-hidden="true"></i>
</a>